import React from "react";
import { TopBarWrapper } from "./styles";
import { FaBars } from "react-icons/fa6";
import { Icon } from "CRM/organism/Main/styles";
import { useLocation } from "react-router-dom";
import { useIsMobile } from "./IsMobile";

export const TopBar = ({ view, setView }) => {
	const location = useLocation();
	const { pathname } = location;
	const current = pathname.split("/admin")[1];
	const isMobile = useIsMobile();

	return (
		<TopBarWrapper
			style={{
				width: view ? "calc(100vw - 280px)" : "100vw",
				position: isMobile ? "fixed" : "relative",
				zIndex: isMobile ? 999 : 0,
			}}
		>
			<Icon
				onClick={() => {
					setView(!view);
					// console.log('TopBarWrapper', view)
				}}
			>
				<FaBars />
			</Icon>
			{current == "" && "HOME"}
			{current == "/db" && "DB관리"}
			{current == "/notice" && "공지사항"}
			{current == "/customer" && "거래고객관리"}
			{current == "/status" && "상태관리"}
			{current == "/path" && "방문경로관리"}
			{current == "/branch" && "페이다 입출금"}
			{current == "/platform" && "플랫폼관리"}
			{process.env.REACT_APP_URL?.includes("ccl") && current == "/board" && "업무요청게시판"}
			{current == "/employee" && "직원관리"}
			{current == "/branchManage" && "지점관리"}
			{current == "/teamManage" && "팀관리"}
			{current == "/setting" && "설정"}
		</TopBarWrapper>
	);
};

export default React.memo(TopBar);
